import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { duplecateNameValidator } from "src/app/directives/duplecate-name-validator";
import { AddBigCommercePayload, AddShopifyAccount, AddWalmartAccount, AddWooCommerceAccount } from "src/app/models/onboarding.model";
import { OnboardingService } from "src/app/services/onboarding.service";
import { HeaderService } from "../../header/header.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { CONTAINER_DATA } from "../marketplace-connections.component";
import { OnlyAlphaNumericValidator } from "src/app/directives/only-alpha-numeric-validator";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-walmart-new-connection",
  templateUrl: "./walmart-new-connection.component.html",
  styleUrls: [
    "../new-connection.scss",
    "./walmart-new-connection.component.scss",
  ],
})
export class WalmartNewConnectionComponent implements OnInit,OnDestroy {
  public addAccountForm: FormGroup;
  spinLoader = false;
  @Output() saved: EventEmitter<boolean> = new EventEmitter();
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  duplicateNameValue: boolean= false;
  duplicateStoreClientValue: boolean= false;
  duplicateKeyValue: boolean= false;
  keyLabelText:any;
  private destroy$ = new Subject<void>();
  walmartMarkets = [
    {
     marketplaceid: "v3",
     name: "Walmart US"
    },
    {
      marketplaceid: "v3/ca",
      name: "Walmart CA"
     }
  ]
  myreg = '(http?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'

  constructor(
    private fb: FormBuilder,
    private onboardingService: OnboardingService,
    private snackBar: MatSnackBar,
    private headerService: HeaderService,
    @Inject(CONTAINER_DATA) public componentData: any
  ) {}

  ngOnInit(): void {
    this.addAccountForm = this.fb.group({
      name: [
        "", [Validators.required,OnlyAlphaNumericValidator]
      ],
      key: ["", [Validators.required]],
      secret: ["", ],
      consumerKey:[''],
      consumerSecret:[''],
      walmartRegion:[''],
      sandboxClient:[''],
      sandboxSecret:['']

    });
    if(this.componentData.channelType == 'shopify' || this.componentData.channelType == 'WooCommerce'){
      this.addAccountForm.get('key').setValidators(Validators.pattern(this.myreg));
    }else if(this.componentData.channelType == 'walmart'){
      this.addAccountForm.get('name').setAsyncValidators([duplecateNameValidator(this.onboardingService)]);
      this.addAccountForm.get('walmartRegion').setValidators(Validators.required);
    }
    this.setValidators()
    
    if(this.componentData.channelType !== 'WooCommerce'){
      this.addAccountForm.get('secret').setValidators(Validators.required);
    }
  }

  validateName(){
  if(this.componentData.channelType !== 'walmart'){
    const name=  this.addAccountForm.get('name').value;
    if(name){     
      this.onboardingService.CheckDuplicateValue('name',name).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:boolean) => {
        this.duplicateNameValue=  res;
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
        this.duplicateNameValue= true;     
       }
     });
    }
  }
  }

  validateKey(isBigCommerce?){
  if(this.componentData.channelType !== 'shopify' && this.addAccountForm.get('key').valid){
    const key= this.addAccountForm.get('key').value;
    const name = isBigCommerce ? 'id2' : 'client';
    if(key){
      this.onboardingService.CheckDuplicateValue(name,key).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:boolean) => {
        this.duplicateStoreClientValue=  res;
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
        this.duplicateStoreClientValue= true;    
       }
     });
    }
  }
  }

  validateWayFair(sandBox){
    const secret=  this.addAccountForm.get(sandBox).value;
    const name = sandBox == 'sandboxClient' ? 'id3' : 'id4'
    if(secret){
      this.onboardingService.CheckDuplicateValue(name,secret).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:boolean) => {
        this.duplicateKeyValue=  res;
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
        this.duplicateKeyValue= true;      
       }
     });
    }
  }

  validateSecret(){
  if(this.componentData.channelType !== 'walmart'){
    const secret=  this.addAccountForm.get('secret').value;
    if(secret){
      this.onboardingService.CheckDuplicateValue('secret',secret).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:boolean) => {
        this.duplicateKeyValue=  res;
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
        this.duplicateKeyValue= true;    
       }
     });
    }
  }
  }

  openWalmartPage() {
    if(this.componentData.channelType === 'wayfair'){
      window.open("https://partners.wayfair.com/developer/applications", "_blank");
    } else{
      window.open("https://developer.walmart.com/generateKey", "_blank");
    }
  }

  saveNewMarketplace() {
    if(this.componentData.channelType === 'walmart'){
      this.addWalmartAccount();
    } else if(this.componentData.channelType === 'shopify'){
      this.addShopifyAccount();
    } else if(this.componentData.channelType === 'WooCommerce'){
      this.addWooCommerceAccount()
    }else if(this.componentData.channelType === 'BigCommerce'){
      this.addBigCommerceAccount();
    }else{
      this.addWayFairAccount();
    }
  }

  addWalmartAccount(){
    this.addAccountForm.patchValue({
      name: this.addAccountForm.get("name").value.trim(),
    });
    this.spinLoader = true;
    this.onboardingService
      .AddWalmartAccount(this.addAccountForm.value as AddWalmartAccount)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (e) => {
          if (!e) {
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'Please verify your credentials or ensure full permission access is enabled',
                    action: 'Dismiss',
                      type: 'error',
                  },
                }
            );
          } else {
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'Your Walmart account was linked successfully',
                    action: 'Dismiss',
                      type: 'success',
                  },
                }
            );
            this.saved.emit(true);
            this.headerService.RefreshDropdown$.next(true);
          }
          this.spinLoader = false;
        },
       error: (err) => {
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Something went wrong',
                  action: 'Dismiss',
                    type: 'error',
                },
              }
          );
          this.spinLoader = false;
           }
     });
  }

  addShopifyAccount(){
    this.spinLoader = true;
    const data = this.addAccountForm.value;
    const payload : AddShopifyAccount ={
      name: data.name,
      storeUrl: 'https://' + data.key,
      secretKey: data.secret,
    }
    this.onboardingService.AddShopifyAccount(payload).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: "Your Shopify account was linked successfully",
            action: 'Dismiss',
            type: 'success',
          },
        }
    );
      this.spinLoader = false;
      this.saved.emit(true);
    },
    error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
      this.spinLoader = false;
     }
   });
  }

  addWayFairAccount(){
    this.spinLoader = true;
    const data = this.addAccountForm.value;
    const payload= {
      name: data.name,
      client: data.key,
      secret: data.secret,
      sandboxClient:data.sandboxClient,
      sandboxSecret:data.sandboxSecret
    }
    this.onboardingService.addWayFairAccount(payload).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: "Your Wayfair account was linked successfully",
            action: 'Dismiss',
            type: 'success',
          },
        }
    );
      this.spinLoader = false;
      this.saved.emit(true);
    },
   error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
      this.spinLoader = false;
     }
   });
  }
  addWooCommerceAccount(){
    this.spinLoader = true;
    const data = this.addAccountForm.value;
    const payload:AddWooCommerceAccount= {
      name:data.name,
      url: 'https://' + data.key,
      consumerKey: data.consumerKey,
      consumerSecret: data.consumerSecret
    }
    this.onboardingService.addWooCommerceAccount(payload).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: "Your WooCommerce account was linked successfully",
            action: 'Dismiss',
            type: 'success',
          },
        }
    );
      this.spinLoader = false;
      this.saved.emit(true);
    },
     error: (err) => {
      this.spinLoader = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
      this.spinLoader = false;
     }
   });
  }

  cancel() {
    this.close.emit();
  }

  setValidators(){
    if(this.componentData.channelType == 'shopify'){
      this.keyLabelText = 'Enter Shop URL and Access Token provided by your marketplace'
    }else if(this.componentData.channelType == 'WooCommerce'){
      this.keyLabelText = 'Enter Shop URL and Consumer Key and Consumer Secret provided by your marketplace'
      this.addAccountForm.get('consumerKey').setValidators(Validators.required);
      this.addAccountForm.get('consumerSecret').setValidators(Validators.required);
    }else if(this.componentData.channelType == 'wayfair'){
      this.addAccountForm.get('sandboxClient').setValidators(Validators.required);
      this.addAccountForm.get('sandboxSecret').setValidators(Validators.required);
      this.keyLabelText = 'Enter client ID and client secret provided by your marketplace'
    }else if(this.componentData.channelType == 'BigCommerce'){
      this.keyLabelText = 'Enter Store Hash and Access Token provided by your marketplace'
    }else{
      this.keyLabelText = 'Enter client ID and client secret provided by your marketplace'
    }
  }
  addBigCommerceAccount(){
    this.spinLoader = true;
    const data = this.addAccountForm.value;
    const payload :AddBigCommercePayload= {
      name:data.name,
      store_hash: data.key,
      access_token: data.secret
    }
    this.onboardingService.addBigCommerceAccount(payload).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: "Your BigCommerce account was linked successfully",
            action: 'Dismiss',
            type: 'success',
          },
        }
    );
      this.spinLoader = false;
      this.saved.emit(true);
    },
    error: (err) => {
      this.spinLoader = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
      this.spinLoader = false;
     }
   });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
